module.exports = __webpack_public_path__ + "static/media/team-pana.6acb5f13.svg";